export default {
  title: 'Waybill',
  list: {
    filterTitle: 'Waybill Filters',
    exportTitle: 'Waybill List'
  },
  fields: {
    waybillNo: 'Waybill No.',
    consignmentNo: 'Related Consignment No.',
    fhNo: 'Related FH No.',
    relatePlanNo: 'Related Transport Plan No.',
    relateFhNo: 'Related Shipment Request No.',
    transportSegment: 'Transport Segment',
    orderStatus: 'Main Status',
    mainTransportMode: 'Transport Mode',
    segmentOrigin: 'Segment Origin',
    segmentDestination: 'Segment Destination',
    mainlineOriginCountry: 'Mainline Origin Country',
    mainlineDestCountry: 'Mainline Destination Country',
    portOfLoadingCode: 'Port of Loading',
    portOfDischargeCode: 'Port of Discharge',
    transportTool: 'Transport Tool',
    transportToolShipName: 'Transport Tool - Vessel',
    transportToolVoyageNo: 'Transport Tool - Voyage',
    transportToolLineCode: 'Transport Tool - Line Code',
    transportToolFlightNo: 'Transport Tool - Flight No.',
    transportToolVehicleLicence: 'Transport Tool - Vehicle Plate',
    transportToolTrainNo: 'Transport Tool - Train No.',
    supplierName: 'Supplier',
    shipper: 'Carrier',
    shipperShipowner: 'Shipping Company',
    shipperAirline: 'Airline',
    shipperExpress: 'Express Company',
    shipperTruckCo: 'Truck Company',
    shipperRailwayCo: 'Railway Company',
    currentTrackingNode: 'Current Tracking Node',
    currentTrackingStatus: 'Current Tracking Status',
    hasException: 'Has Exception',
    blType: 'BL Type',
    blNo: 'BL No.',
    expressWaybillNo: 'Express Waybill No.',
    packageBarcodeList: 'Package Barcode',
    orderNo: 'Cooperation No.',
    carrierName: 'Voyage Carrier',
    originPlace: 'Voyage Origin',
    destinationPlace: 'Voyage Destination',
    etd: 'ETD',
    eta: 'ETA',
    atd: 'ATD',
    ata: 'ATA',
    transitType: 'Transit Type',
    transitPoints: 'Transit Points',
    schedule: 'Schedule',
    vesselName: 'Vessel',
    voyageNo: 'Voyage',
    lineCode: 'Line Code',
    flightNo: 'Flight No.',
    vehicleNo: 'Vehicle Plate',
    vesselVoyage: 'Vessel/Voyage',
    aircraftType: 'Aircraft Type',
    airDuration: 'Air Duration',
    expressProduct: 'Express Product',
    railTrainNo: 'Train No.',
    vehicleLicence: 'Vehicle Plate',
    driverName: 'Driver Name',
    driverPhone: 'Phone',
    driverIdNo: 'ID No.',
    vehicleType: 'Vehicle Type',
    containerNo: 'Container No.',
    boxNos: 'Container No.',
    createdAt: 'Created At',
    updatedAt: 'Modified At',
    remark: 'Remark',
    operation: 'Operation'
  },
  placeholders: {
    keyword: 'Enter keywords',
    batchKeyword: 'Enter multiple keywords separated by space, comma, or semicolon',
    select: 'Please select',
    dateRange: 'Select date range',
    waybillNo: 'Enter waybill no.',
    consignmentNo: 'Enter consignment no.',
    relatePlanNo: 'Enter transport plan no.',
    relateFhNo: 'Enter shipment request no.',
    fhNo: 'Enter FH no.',
    origin: 'Enter or select origin',
    destination: 'Enter or select destination',
    mainlineOriginCountry: 'Select mainline origin country',
    mainlineDestCountry: 'Select mainline destination country',
    portOfLoadingCode: 'Enter port of loading code',
    portOfDischargeCode: 'Enter port of discharge code'
  },
  tags: {
    bl: 'BL',
    express: 'Express',
    land: 'Land',
    rail: 'Rail',
    waybill: 'Waybill'
  },
  trackingStatuses: {
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed'
  },
  orderStatuses: {
    created: 'Created',
    operating: 'In Operation',
    completed: 'Completed',
    cancelled: 'Cancelled',
    frozen: 'Frozen'
  },
  exceptionLevels: {
    normal: 'Normal',
    minor: 'Minor',
    major: 'Major',
    critical: 'Critical'
  },
  exceptionOptions: {
    yes: 'Has Exception',
    no: 'No Exception'
  },
  trackingDetail: {
    title: 'Tracking Trajectory',
    empty: 'No tracking trajectory',
    actions: {
      packingDetail: 'Packing Details'
    },
    etowerPush: {
      retry: 'Retry Push',
      failureHint: 'Complete and save the consignment information before retrying',
      status: {
        pending: 'Push in Progress',
        processing: 'Push in Progress',
        success: 'Push Successful',
        failed: 'Push Failed',
        unknown: 'Push Result Unknown, Please Check Manually'
      }
    },
    attachments: {
      select: 'Select',
      upload: 'Upload',
      selectTitle: 'Select File Management Attachments',
      uploadTitle: 'Upload Attachment',
      noFiles: 'No files',
      fileType: 'File Type',
      fileTypePlaceholder: 'Select file type',
      file: 'File',
      chooseFile: 'Choose File',
      filePlaceholder: 'No file selected',
      fileTypeRequired: 'Select a file type',
      fileRequired: 'Choose a file',
      fileIdMissing: 'File ID is missing',
      orderIdMissing: 'Order ID is missing, cannot update attachments',
      loadFilesFailed: 'Failed to load file management attachments',
      downloadFailed: 'Failed to download attachment',
      uploadSuccess: 'Attachment uploaded to file management. Save to bind it to the node.',
      uploadFailed: 'Failed to upload attachment',
      columns: {
        fileName: 'File Name',
        fileType: 'File Type',
        uploadTime: 'Upload Time',
        fileSize: 'File Size'
      }
    },
    fields: {
      nodeCode: 'Event Code',
      nodeName: 'Node Name',
      stageName: 'Stage',
      nodeStatus: 'Node Status',
      location: 'Location',
      expressNo: 'Tracking No.',
      consignmentNo: 'Order No.',
      createdAt: 'Order Time',
      pickupTime: 'Pickup Time',
      pickupLocation: 'Pickup Location',
      transportTime: 'Transport Time',
      clearanceTime: 'Clearance Time',
      clearanceLocation: 'Clearance Location',
      deliveryTime: 'Delivery Time',
      signTime: 'Sign Time',
      estimatedTime: 'Estimated Time',
      actualTime: 'Actual Time',
      exceptionLevel: 'Exception Level',
      estimatedRemark: 'Estimated Remark',
      actualRemark: 'Actual Remark',
      exceptionRemark: 'Exception Remark',
      attachment: 'Attachment'
    },
    timePrefixes: {
      estimated: 'EST',
      actual: 'ACT'
    },
    expressTypes: {
      external: 'Express Tracking',
      domestic: 'Domestic Express',
      international: 'International Express'
    },
    duration: {
      daysHours: '{days}d {hours}h',
      days: '{days}d',
      hours: '{hours}h'
    },
    summary: {
      separator: ': ',
      waybillNo: 'Related Waybill No.',
      packageBarcodeList: 'Package Barcode',
      shipowner: 'Shipping Company',
      vesselName: 'Vessel',
      voyageNo: 'Voyage',
      lineCode: 'Line Code',
      etd: 'ETD',
      eta: 'ETA',
      ata: 'ATA',
      atd: 'ATD',
      estimatedDuration: 'Estimated Duration',
      actualDuration: 'Actual Duration',
      airline: 'Airline',
      flightNo: 'Flight No.',
      aircraftType: 'Aircraft Type',
      expressCompany: 'Express Carrier',
      expressProduct: 'Express Product',
      railTrainNo: 'Rail Train',
      vehicleLicence: 'Vehicle Plate',
      driverName: 'Driver Name',
      driverPhone: 'Phone',
      driverIdNo: 'ID No.',
      vehicleType: 'Vehicle Type'
    }
  },
  detail: {
    title: 'Waybill Detail',
    tabs: {
      basic: 'Basic Info',
      tracking: 'Tracking'
    },
    actions: {
      refresh: 'Refresh',
      edit: 'Edit',
      save: 'Save',
      cancel: 'Cancel',
      addPacking: 'Add Packing Item',
      downloadPackingTemplate: 'Download Template',
      importPackingExcel: 'Import Excel',
      addNotify: 'Add Notify Party',
      delete: 'Delete',
      operationHistory: 'Operation History'
    },
    edit: {
      title: 'Edit Waybill'
    },
    empty: {
      contact: 'No shipping parties',
      operationHistory: 'No operation history'
    },
    placeholders: {
      select: 'Please select'
    },
    sections: {
      base: 'Waybill Basic Info',
      contact: 'Shipping Parties',
      voyage: 'Voyage Info',
      cargoSummary: 'Actual Cargo Summary',
      packing: 'Packing List',
      tracking: 'Tracking'
    },
    baseFields: {
      mainTransportMode: 'Transport Mode',
      origin: 'Origin',
      destination: 'Destination',
      orderRemark: 'Transport Remark',
      supplierRemark: 'Supplier Remark'
    },
    boolean: {
      yes: 'Yes',
      no: 'No'
    },
    voyageFields: {
      seaCarrier: 'Shipping Company',
      placeOfReceipt: 'Place of Receipt',
      seaOriginPort: 'POL',
      dischargePort: 'Discharge Port',
      destinationPort: 'Destination Port',
      loadingTerminal: 'Origin Terminal',
      destinationTerminal: 'Destination Terminal',
      seaTransitType: 'Direct/Transit',
      transshipmentPort: 'Transshipment Port',
      vesselName: 'Vessel',
      voyageNo: 'Voyage',
      lineCode: 'Line Code',
      sailingSchedule: 'Sailing Schedule',
      customsCutoffSchedule: 'Customs Cutoff Schedule',
      etd: 'ETD',
      eta: 'ETA',
      ata: 'ATA',
      atd: 'ATD',
      destinationFreeContainerDays: 'Destination Free Container Days',
      destinationFreeStorageDays: 'Destination Free Storage Days',
      devanningDelivery: 'Devanning Delivery',
      weightLimit: 'Weight Limit',
      specialInstruction: 'Special Instruction',
      voyageRemark: 'Remark',
      airline: 'Airline',
      pickupPlace: 'Pickup Place',
      originAirport: 'Origin Airport POL',
      destinationAirport: 'Destination Airport POD',
      airDestination: 'Destination',
      airTransitType: 'Direct/Transit',
      transitAirport: 'Transit Airport',
      flightNo: 'Flight No.',
      aircraftType: 'Aircraft Type',
      flightSchedule: 'Flight Schedule',
      airDuration: 'Duration',
      spaceVolumeLimitCbm: 'Space Volume Limit (CBM)',
      destinationAirportFreeStorageDays: 'Destination Airport Free Storage Days',
      cfsFreeStorageDays: 'CFS Free Storage Days',
      expressCarrier: 'Express Carrier',
      expressProduct: 'Express Product',
      railTrainNo: 'Rail Train No.',
      railOriginStation: 'Origin Station',
      railDestinationStation: 'Destination Station',
      vehicleLicence: 'Vehicle Plate',
      driverName: 'Driver Name',
      driverPhone: 'Phone',
      driverIdNo: 'ID No.',
      vehicleType: 'Vehicle Type',
      landOrigin: 'Origin',
      landDestination: 'Destination'
    },
    contactFields: {
      partyType: 'Type',
      company: 'Company',
      contactName: 'Contact',
      phone: 'Phone',
      country: 'Country',
      province: 'Province/State',
      city: 'City',
      district: 'District',
      town: 'Town/Street',
      address: 'Address',
      postcode: 'Postcode',
      operation: 'Operation'
    },
    partyTypes: {
      shipper: 'Shipper',
      consignee: 'Consignee',
      notify: 'Notify Party',
      customsShipper: 'Customs Shipper Address',
      customsConsignee: 'Customs Consignee Address',
      clearanceShipper: 'Clearance Shipper Address',
      clearanceConsignee: 'Clearance Consignee Address',
      actualPickup: 'Actual Pickup Address',
      actualDelivery: 'Actual Delivery Address'
    },
    cargoFields: {
      pieces: 'Cartons',
      grossWeight: 'Gross Weight (KGS)',
      volume: 'Volume (CBM)',
      chargeableWeight: 'Chargeable Weight (KGS)',
      palletSize: 'Pallet Size (L×W×H cm)',
      palletQty: 'Pallet Qty'
    },
    packingFields: {
      lineNo: 'Line No.',
      containerNo: 'Container No.',
      containerType: 'Container Type',
      palletNo: 'Pallet No.',
      sealNo: 'Seal No.',
      pieces: 'Cartons',
      grossWeight: 'Gross Weight (KGS)',
      volume: 'Volume (CBM)',
      goodsNameEn: 'Goods Name EN',
      marks: 'Marks',
      cartonNos: 'Carton Nos',
      remark: 'Remark',
      operation: 'Operation'
    },
    operationHistory: {
      title: 'Operation History'
    },
    packingTemplate: {
      fileName: 'Packing List Template.xlsx',
      sheetName: 'Packing List'
    }
  },
  messages: {
    loadListFailed: 'Failed to load waybill list',
    loadDetailFailed: 'Failed to load waybill detail',
    saveDetailSuccess: 'Waybill detail saved',
    saveDetailFailed: 'Failed to save waybill detail',
    contactPartyRequired: 'Shipping parties require exactly one shipper and one consignee',
    contactAddressRequired: 'Contact, phone and country are required for shipping parties',
    customsContactAddressRequired: 'Phone and country are required for customs and clearance addresses',
    fieldRequired: '{field} is required',
    packingRequired: 'Packing row {line}: {field} is required',
    downloadPackingTemplateFailed: 'Failed to download packing template',
    importPackingSuccess: 'Imported {count} packing rows',
    importPackingFailed: 'Failed to import packing list',
    packingWorksheetMissing: 'No worksheet found',
    packingHeaderMissing: 'No packing list header matched',
    packingNoData: 'The Excel file has no importable data',
    importPackingOverwriteTitle: 'Overwrite packing list?',
    importPackingOverwriteContent: 'Importing Excel will replace the current packing list.',
    trackingNodeRequired: 'Tracking node is missing waybill no. or node identity and cannot be saved',
    loadOperationHistoryFailed: 'Failed to load operation history',
    idRequired: 'Waybill ID is required',
    deleteConfirmTitle: 'Delete waybill?',
    deleteConfirmContent: 'After deleting waybill {no}, the tracking data on the transport consignment detail page will be deleted as well.',
    deleteSuccess: 'Waybill deleted',
    deleteFailed: 'Failed to delete waybill, please try again'
  }
}
